

export default {
  enums: [
    { id: 'ALL', },
    { id: 'UNIT', },
    { id: 'PACK', },
  ]
};
